import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "vault_stock_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers["X-Auth-Token"] = t;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            clearToken();
            const p = window.location.pathname;
            if (p !== "/" && p !== "/login") {
                window.location.href = "/";
            }
        }
        return Promise.reject(err);
    }
);

export const formatMoney = (n) => {
    const val = Number(n || 0);
    const formatted = new Intl.NumberFormat("fr-FR", {
        maximumFractionDigits: 0,
    }).format(val);
    return `$${formatted}`;
};

export const CATEGORY_COLORS = {
    blue: "bg-sky-100 text-sky-800 border-sky-200",
    emerald: "bg-emerald-100 text-emerald-800 border-emerald-200",
    rose: "bg-rose-100 text-rose-800 border-rose-200",
    amber: "bg-amber-100 text-amber-800 border-amber-200",
    violet: "bg-violet-100 text-violet-800 border-violet-200",
    slate: "bg-slate-100 text-slate-800 border-slate-200",
};

export const LOCATIONS = [
    { key: "club", label: "Club" },
    { key: "entrepot", label: "Entrepôt" },
    { key: "cache", label: "Caché" },
    { key: "blanchiment", label: "Blanchiment" },
];

export const LOCATION_LABEL = {
    club: "Club",
    entrepot: "Entrepôt",
    cache: "Caché",
    blanchiment: "Blanchiment",
};
